export enum NotificationMessageType {
  Error,
  Warning
}